<script lang='ts'>
import type { RouteLocationMatched } from 'vue-router'
import * as R from 'ramda'
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'MsBreadcrumbHeader',
  setup() {
    const route = useRoute()
    const breadcrumbItems = computed(() => {
      return R.filter((item: RouteLocationMatched) => !(!item.meta || !item.meta.showInBreadcrumb || !item.meta.title))(route.matched || [])
    })
    const itemTo = (item: RouteLocationMatched, index: number) => {
      return (route.name === item.name || (index === breadcrumbItems.value.length - 1 && item.redirect)) ? '' : item.path
    }
    return {
      breadcrumbItems,
      itemTo,
    }
  },
})
</script>

<template>
  <div class="wrapper">
    <div class="left">
      <el-breadcrumb>
        <template v-for="(item, index) in breadcrumbItems" :key="index">
          <el-breadcrumb-item :replace="!!item.replace" :to="itemTo(item, index)">
            {{ item.meta.title }}
          </el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <slot />
  </div>
</template>

<style lang='scss' scoped>
.wrapper {
  display: flex;
  margin-bottom: $space-md;
  min-height: 32px;

  .left {
    flex: 1;
    display: flex;
    align-items: center;
  }
}
</style>
